<template>
  <div class="container">
    <el-header class="el-header" style=" justify-content: center">
        <h1 class="el-row1" style="align-content: center;font-size: 28px;">Download Data</h1>
      </el-header>
    <div class="el-row">
      <el-col :span="6">
        <h5 class="el-row1" style="justify-content: center ;margin-top: 5px">Filter your results</h5>
<!--        选择菜单-->
<!--        <el-menu id ='menu'-->
<!--            style="background-color: #e2dfdf"-->
<!--            class="el-menu-vertical-demo"-->
<!--            default-active="1"-->
<!--            @open="handleOpen"-->
<!--            @close="handleClose"-->
<!--        >-->
<!--&lt;!&ndash;          性别&ndash;&gt;-->
<!--          <el-menu-item index="1">-->
<!--            <template slot="title" id="1" @click="showall">-->
<!--              <span>All</span>-->
<!--            </template>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="2">-->
<!--            <template slot="title" id="gender"  @click="showgen">-->
<!--              <span>Participants' gender</span>-->
<!--            </template>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="3">-->
<!--            <span slot="title" id="edu" @click="showedu">-->
<!--              Participants' education level</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="4">-->
<!--            <span slot="title" id="language_background"  @click="languagebk">-->
<!--              Participants' subtest background</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="5">-->
<!--            <span slot="title" id="subtest"  @click="chosesubtest">-->
<!--              Subtest</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="6">-->
<!--            <span slot="title" id="modality"  @click="chosemodality">-->
<!--              Test modality</span>-->
<!--          </el-menu-item>-->
<!--        </el-menu>-->

<!--        筛选按钮-->

          <!--       ALL   -->
        <div class="menu">
        <el-button class="menubutten" @click="showall" >All</el-button>
        <el-button class="menubutten" @click="showgen" >Participants' gender</el-button>
        <el-button class="menubutten" @click="showedu" >Participants' education level</el-button>
        <el-button class="menubutten" @click="languagebk" >Participants' language background</el-button>
        <el-button class="menubutten" @click="chosesubtest" >Subtest</el-button>
        <el-button class="menubutten" @click="chosemodality" >Test modality</el-button>
        </div>
      </el-col>
<!--      显示筛选结果-->
      <el-col :span="18">
        <div class="page" style="margin-left: 50px">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchdata.pageindex"
              :page-sizes="[10, 20]"
              :page-size="searchdata.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tabledata.length">
          </el-pagination>
<!--显示结果的表格-->
          <el-table
              :data="tabledata.slice((searchdata.pageindex-1)*searchdata.pageSize,searchdata.pageindex*searchdata.pageSize)"
              style="width: 800px;text-align: center">
            <el-table-column prop="index" label="index" width="80px"></el-table-column>
            <el-table-column prop="data" label="data" width="500px"></el-table-column>
            <el-table-column fixed="right" label="operation" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">download</el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
      </el-col>

    </div>
    <el-dialog
        title="Filter your results"
        :visible.sync="centerDialogVisible"
        width="70%"
        style="font-size: 26px;"
        left>
      <span>
        <div slot="title" class="header-title">
          <h3 v-show="cur==3" class="el-row-dialog" style="justify-content: center ;margin-top: 0px">
           Please choose second language background of participants
          </h3>
          <h3 v-show="cur==4" class="el-row-dialog" style="justify-content: center ;margin-top: 0px">
           Please choose Subtest
          </h3>
          <h3 v-show="cur==5" class="el-row-dialog" style="justify-content: center ;margin-top: 0px">
           Please choose test modality
         </h3>
        </div>

        <div class="filter">
          <el-tree
              :data="filterdata"
              show-checkbox
              default-expand-all
              node-key="id"
              ref="tree"
              highlight-current
              >
          </el-tree>
        </div>
      </span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelfilter">Close<br/>

        </el-button>
        <el-button type="primary" @click="filterresults">OK<br/>

        </el-button>
      </span>

    </el-dialog>
  </div>


</template>

<script>
import GLOBAL from "../../plugins/global_variable";
export default {
  name: "dataindex",
  data() {
    return {
      edu:'',
      country:'',
      centerDialogVisible: false,
      filterdata:[],
      currentPage:1,
      cur:'',

      searchdata: {
        pageSize: 10,
        pageindex: 1
      },//页码，页长
      total: 0,//总数据长度
    //  结果表格中的数据
      tabledata: [
        { index: 1, data: 'tall_gender_male.zip',},
        { index: 2, data: 'tall_gender_female.zip',},
        { index: 3, data: 'tall_gender_other.zip',},
        { index: 4, data: 'tall_edu_junior school.zip',},
        { index: 5, data: 'tall_edu_senior high school.zip',},
        { index: 6, data: 'tall_edu_higher vocational college.zip',},
        { index: 7, data: 'tall_edu_undergraduate.zip',},
        { index: 8, data: 'tall_edu_graduate.zip',},
        { index: 9, data: 'tall_foreign language_English.zip',},
        { index: 10, data: 'tall_foreign language_Others.zip',},
        { index: 11, data: 'tall_subtest_Vocabulary Learning.zip',},
        { index: 12, data: 'tall_subtest_Sound Discrimination.zip',},
        { index: 13, data: 'tall_subtest_Language Analysis.zip',},
        { index: 14, data: 'tall_subtest_Serial Non-Word Recall.zip',},
        { index: 15, data: 'tall_subtest_Complex Span Task.zip',},
        { index: 16, data: 'tall_testModality_Aural Modality.zip',},
        { index: 17, data: 'tall_testModality_Written Modality.zip',},
        { index: 18, data: 'tall_All.zip',},
      ],
  }},
  methods:{
    created() {
      document.body.style.backgroundColor="#DCDCDC";
    },

    // datadownload(cur, com){
    //   GLOBAL.cur = cur
    //   GLOBAL.com = com
    //   console.log(GLOBAL.cur)
    //   console.log(GLOBAL.com)
    //   this.$router.push('/dataquestionnaire')
    //
    // },

    //筛选器
    languagebk(){
      var _this = this
      _this.cur = 3
      GLOBAL.cur = _this.cur
      _this.centerDialogVisible = true
      _this.filterdata=[{
        id: 1,
        label: 'English',
        },
        {
          id: 2,
          label: 'Other subtest(s)',
        },
      ]
    },

    chosesubtest(){
      var _this = this
      _this.cur = 4
      GLOBAL.cur = _this.cur
      _this.centerDialogVisible = true
      _this.filterdata=[{
        id: 1,
        label: 'Vocabulary Learning',
      },
        {
          id: 2,
          label: 'Sound Discrimination',
        },
        {
          id: 3,
          label: 'Language Analysis',
        },
        {
          id: 4,
          label: 'Serial Non-Word Recall',
        },
        {
          id: 5,
          label: 'Complex Span Task',
        },
      ]
    },

    chosemodality(){
      var _this = this
      _this.cur = 5
      GLOBAL.cur = _this.cur
      _this.centerDialogVisible = true
      _this.filterdata=[{
        id: 1,
        label: 'Aural Modality',
      },
        {
          id: 2,
          label: 'Written Modality',
        },

      ]

    },

    //获得选中的label
    filterresults(){
      var _this = this
      var checkdata = _this.$refs.tree.getCheckedNodes()
      console.log(checkdata)
      let label_arr = []
      _this.tabledata =[]
      for(var i = 0; i < checkdata.length; i++){
        if(_this.cur==3){
          label_arr.push(checkdata[i].label)
          _this.tabledata.push({index:i+1, data:"tall_foreign language_"+checkdata[i].label+".zip"})
        }
        if(_this.cur==4){
          label_arr.push(checkdata[i].label)
          _this.tabledata.push({index:i+1, data:"tall_subtest_"+checkdata[i].label+".zip"})
        }
        if(_this.cur==5){
          label_arr.push(checkdata[i].label)
          _this.tabledata.push({index:i+1, data:"tall_testModality_"+checkdata[i].label+".zip"})
        }


      }
      _this.removebyvalue(label_arr, undefined)
      //获取选中的label-array
      console.log(label_arr)
      this.centerDialogVisible=false
      //返回筛选的结果label
      return label_arr
    },
    removebyvalue(arr, value){
      for(var i =0; i < arr.length; i++){
        if(arr[i]==value){
          arr.splice(i,1);
          break;
        }
      }
    },

    //清除所选数据
    cancelfilter(){
      this.$refs.tree.setCheckedKeys([])
      this.centerDialogVisible=false
    },

    //显示结果
    handleSizeChange(val) {
      this.searchdata.pageSize = val;
      console.log(`每页 ${val} 条`);

    },
    handleCurrentChange(val) {
      this.searchdata.pageindex = val;
      console.log(`当前页: ${val}`);
      console.log(this.list)
    },

    showall(){

      console.log("all")
      this.tabledata=[
        { index: 1, data: 'tall_gender_male.zip',},
        { index: 2, data: 'tall_gender_female.zip',},
        { index: 3, data: 'tall_gender_other.zip',},
        { index: 4, data: 'tall_edu_junior school.zip',},
        { index: 5, data: 'tall_edu_senior high school.zip',},
        { index: 6, data: 'tall_edu_higher vocational college.zip',},
        { index: 7, data: 'tall_edu_undergraduate.zip',},
        { index: 8, data: 'tall_edu_graduate.zip',},
        { index: 9, data: 'tall_foreign language_English.zip',},
        { index: 10, data: 'tall_foreign language_Others.zip',},
        { index: 11, data: 'tall_subtest_Vocabulary Learning.zip',},
        { index: 12, data: 'tall_subtest_Sound Discrimination.zip',},
        { index: 13, data: 'tall_subtest_Language Analysis.zip',},
        { index: 14, data: 'tall_subtest_Serial Non-Word Recall.zip',},
        { index: 15, data: 'tall_subtest_Complex Span Task.zip',},
        { index: 16, data: 'tall_testModality_Aural Modality.zip',},
        { index: 17, data: 'tall_testModality_Written Modality.zip',},
        { index: 18, data: 'tall_All.zip',},

      ]
    },


    showgen(){
      console.log("gender")
      this.tabledata=[
        {index: 1, data:"tall_gender_male.zip",},
        {index: 2, data:"tall_gender_female.zip",},
        {index: 3, data:"tall_gender_other.zip",}]

    },

    showedu(){
      console.log("edu")
      this.tabledata=[
        {index: 1,data:"tall_edu_junior school.zip",},
        {index: 2,data:"tall_edu_senior high school.zip",},
        {index: 3,data:"tall_edu_higher vocational college.zip",},
        {index: 4,data:"tall_edu_undergraduate.zip",},
        {index: 5,data:"tall_edu_graduate.zip",},
      ]
    },

    handleClick(row) {
      console.log(row);
      var data = row.data
      var cut = data.indexOf(".")
      var dataname = data.substring(0,cut)

      GLOBAL.dataname = dataname
      console.log(GLOBAL.dataname)
      this.$router.push('/dataquestionnaire')
    },



  },

}
</script>

<style scoped>
.container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  background: #e2dfdf;
  height: 1200px;
}

.header {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  background: #e2dfdf;
  height: 1000px;
}

.filter{
  margin-top:10px;
}
.footer {
  height: 75px;
}

.content {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.el-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 700px;
}

.el-row2 {
  display: flex;
  flex-direction: row;


}


.el-header{
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #D8D8D8;
  margin-bottom: 0rem;
}

.el-row1{
  font-size:24px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;


}

.left, .right {
  width: 400px;
}

.center {
  flex: 1;
}

.row {
  display: flex;
  justify-content: space-around;
  margin-bottom: 80px
}

.datadownload{
  margin-top: 50px;
  margin-left: 50px;
  width: 250px;
  height: 290px;
  background-color:#DCDCDC;

}
.menubutten{
  margin-left: 10px;
  margin-top: 15px;
  width: 250px;
  background-color:  #e2dfdf;
}
</style>